import React, { useLayoutEffect, useState } from 'react';
import PropTypes from 'prop-types';

import styles from './index.module.scss';

const LandingPage = ({ children, isParallaxEffectEnabled = false, ...props }) => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isPreferReducedMotion, setPreferReducedMotion] = useState(false);

  useLayoutEffect(() => {
    if (typeof window !== 'undefined') {
      if (window.scrollY > 5) {
        setIsScrolled(true);
      }

      setPreferReducedMotion(window.matchMedia('(prefers-reduced-motion: reduce)').matches);
    }
  }, []);

  return (
    <div
      className={`page landing ${styles.landing} ${isParallaxEffectEnabled ? styles['landing__with-parallax-effect'] : ''} ${isScrolled ? styles['landing__scrolled'] : styles['landing__not-scrolled']} ${!isPreferReducedMotion ? styles['landing__full_motion'] : styles['landing__reduce_motion']}`}
      {...props}
    >
      {children}
    </div>
  );
};

LandingPage.propTypes = {
  isParallaxEffectEnabled: PropTypes.bool,
};

export default LandingPage;
